import { render, staticRenderFns } from "./CreatePeople.vue?vue&type=template&id=b91a717c"
import script from "./CreatePeople.vue?vue&type=script&lang=js"
export * from "./CreatePeople.vue?vue&type=script&lang=js"
import style0 from "./CreatePeople.vue?vue&type=style&index=0&id=b91a717c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports